import { useSelector } from "react-redux";
import { IState } from "../../store";

export const useLanguage = () => useSelector((state: IState) => state.language.value);